import React from 'react';
import { useLang } from '@/i18n/LanguageContext';
import PageContainer from '@/components/PageContainer';
import PageHeader from '@/components/PageHeader';

export default function Honoraires() {
  const { t } = useLang();
  const h = t.honoraires;

  return (
    <PageContainer>
      <PageHeader kicker={h.kicker} title={h.title} lead={h.intro} />

      <p className="mt-10 text-navy/80 text-lg animate-fade-up text-justify">{h.modesIntro}</p>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
        {h.modes.map((mode, i) => (
          <article
            key={i}
            className="relative bg-white p-7 lg:p-8 border-t-4 border-[var(--color-gold)] shadow-sm hover:shadow-xl transition-shadow duration-500 flex flex-col"
            data-testid={`fee-mode-${i}`}
          >
            <p className="text-[10px] tracking-[0.4em] uppercase text-[var(--color-taupe)] font-semibold mb-3">
              0{i + 1}
            </p>
            <h3 className="font-display text-2xl text-navy mb-4 leading-tight">
              {mode.title}
            </h3>
            <div className="h-px w-10 bg-[var(--color-gold)] mb-5" />
            <p className="text-navy/75 text-[14.5px] leading-relaxed flex-1">{mode.text}</p>
          </article>
        ))}
      </div>
    </PageContainer>
  );
}
